/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, total: NonNullable<unknown> }} History_Transfer_Matched_CountInputs */

const en_us2_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} of ${i?.total} exercises matched`)
};

const pt_br2_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} de ${i?.total} exercícios reconhecidos`)
};

const es_419_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} de ${i?.total} ejercicios reconocidos`)
};

const pt_pt2_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} de ${i?.total} exercícios reconhecidos`)
};

const fr_fr2_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} exercices sur ${i?.total} reconnus`)
};

const de_de2_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} von ${i?.total} Übungen zugeordnet`)
};

const it_it2_history_transfer_matched_count = /** @type {(inputs: History_Transfer_Matched_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.matched} di ${i?.total} esercizi riconosciuti`)
};

/**
* | output |
* | --- |
* | "{matched} of {total} exercises matched" |
*
* @param {History_Transfer_Matched_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_matched_count = /** @type {((inputs: History_Transfer_Matched_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Matched_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_matched_count(inputs)
	if (locale === "es-419") return es_419_history_transfer_matched_count(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_matched_count(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_matched_count(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_matched_count(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_matched_count(inputs)
	return en_us2_history_transfer_matched_count(inputs)
});
export { history_transfer_matched_count as "history-transfer.matched_count" }